import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import * as S from '../style'

interface Item {
  label: string
  component: FC<any>
  props?: any
}

interface TabProps {
  items: Item[]
  children?: ReactNode
  activeIndex?: number
  onTabChange?: (index: number) => void
}

const Tab: FC<TabProps> = ({ items, children, activeIndex, onTabChange }) => {
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([])
  const [sliderDimensions, setSliderDimensions] = useState({
    width: 0,
    left: 0,
    shouldAnimate: false,
  })

  const [currentIndex, setCurrentIndex] = useState<number>(
    typeof activeIndex === 'number' ? activeIndex : 0,
  )

  useEffect(() => {
    const activeTabRef = tabRefs.current[currentIndex]
    if (activeTabRef) {
      const { offsetWidth: width, offsetLeft: left } = activeTabRef
      setSliderDimensions((prev) => ({
        width,
        left,
        shouldAnimate: prev.width !== 0,
      }))
    }
  }, [currentIndex])

  const { component: Component, props = {} } = items[currentIndex] || {}

  const handleTabClick = (_label: string, index: number) => {
    setCurrentIndex(index)
    if (typeof onTabChange === 'function') {
      onTabChange(index)
    }
  }

  return (
    <>
      <S.StyleTabButtonContainer>
        <S.SlidingBackground
          $width={sliderDimensions.width}
          $left={sliderDimensions.left}
          $shouldAnimate={sliderDimensions.shouldAnimate}
        />

        {items.map((item, index) => (
          <S.StyleTabButton
            key={index}
            ref={(el) => (tabRefs.current[index] = el)}
            $active={currentIndex === index}
            onClick={() => handleTabClick(item.label, index)}
          >
            {item.label}
          </S.StyleTabButton>
        ))}
      </S.StyleTabButtonContainer>

      <S.StyleChildrenWrapper>
        {Component ? <Component {...props} /> : null}
      </S.StyleChildrenWrapper>
    </>
  )
}

export default Tab
